import React from "react";
import useClasses from "hooks/useClasses";
import styles from "./CollectableStyle";
import TimelineData from "./TimelineData";
import { collect } from "store/actions/collectables";

const Request = ({ collectable }) => {
  const classes = useClasses(styles);
  return (
    <div>
      <h2 className={classes.sectionTitle}>Request Status Data:</h2>
      {collectable.is_processing === 1 ? (
        <>
          <div>
            {collectable.evaluate_by &&
            String(collectable.evaluate_by).toLowerCase() !== "ai" ? (
              <>
                <span className={classes.label}>will be evaluated by:</span>
                <span className={classes.content}>
                  {collectable.evaluate_by}
                </span>
              </>
            ) : (
              <span className={classes.content}>
                waiting to be evaluated by Human
              </span>
            )}
          </div>
          {collectable.evaluate_ai != null &&
            collectable.evaluate_ai !== "" &&
            (!collectable.evaluate_by ||
              String(collectable.evaluate_by).toLowerCase() === "ai") && (
              <div>
                <span className={classes.content}>
                  (AI evaluation{" "}
                  {String(collectable.evaluate_ai).endsWith("%")
                    ? collectable.evaluate_ai
                    : `${collectable.evaluate_ai}%`}
                  )
                </span>
              </div>
            )}
        </>
      ) : (
        <>
          {collectable.evaluate_by != null &&
            collectable.evaluate_by !== "" && (
              <div>
                <span className={classes.label}>Evaluated By:</span>
                <span className={classes.content}>
                  {collectable.evaluate_by}
                </span>
              </div>
            )}
          {collectable.evaluate_ai != null &&
            collectable.evaluate_ai !== "" &&
            (!collectable.evaluate_by ||
              String(collectable.evaluate_by).toLowerCase() === "ai") && (
              <div>
                <span className={classes.label}>Evaluate AI:</span>
                <span className={classes.content}>
                  {String(collectable.evaluate_ai).endsWith("%")
                    ? collectable.evaluate_ai
                    : `${collectable.evaluate_ai}%`}
                </span>
              </div>
            )}
        </>
      )}
      {collectable.evaluate_ai_description != null &&
        collectable.evaluate_ai_description !== "" && (
          <div>
            <span className={classes.label}>Evaluate AI Description:</span>
            <span className={classes.content}>
              {collectable.evaluate_ai_description}
            </span>
          </div>
        )}

      <div>
        <span className={classes.label}>Save To Cart Date:</span>
        <span className={classes.content}>
          {new Date(collectable.created_at).toLocaleString()}
        </span>
      </div>
      <div>
        <span className={classes.label}>Is Collected:</span>
        {collectable.is_collected === 1 ? (
          <span className={classes.content}>
            Is Collected by {collectable.agent_name} at{" "}
            {new Date(collectable.collected_time).toLocaleString()}
          </span>
        ) : (
          <span>Not Collected</span>
        )}
      </div>
      <div>
        <span className={classes.label}>Is Expired:</span>
        <span className={classes.content}>
          {collectable.is_expired === 1 ? "Expired" : "Not Expired"}
        </span>
      </div>
      <div>
        <span className={classes.label}>Expired on:</span>
        <span className={classes.content}>
          {new Date(collectable.expiry_date).toLocaleString()}
        </span>
      </div>
      <div>
        <span className={classes.label}>Is Archived:</span>
        <span className={classes.content}>
          {collectable.is_archived === 1 ? "Archived" : "Not Archived"}
        </span>
      </div>
      <div>
        <span className={classes.label}>Request Status:</span>
        <TimelineData collectable={collectable} />
      </div>
    </div>
  );
};

export default Request;
